import styled, {css} from 'styled-components';

import BaseCloseIcon from '@edna/icons/close.svg';
import BaseUploadIcon from '@edna/icons/upload.svg';

import {mixins} from '../styles';

type TAreaProps = {
  isInvalid?: boolean;
  multiple?: boolean;
  disabled?: boolean;
  readOnly?: boolean;
};

type TFileProps = {
  isInvalid?: boolean;
  disabled?: boolean;
};

type TInputProps = {
  disabled?: boolean;
  readOnly?: boolean;
};

export const Area = styled.label<TAreaProps>`
  ${mixins.input}
  ${mixins.flexAlign('center')}
  position: relative;
  flex-direction: column;
  height: 100px;
  caret-color: transparent;
  overflow: hidden;
  opacity: 0.85;
  cursor: pointer;

  ${({theme, disabled, readOnly}) => css`
    background-color: ${theme.palette.white};
    transition: color ${theme.animation.duration}ms;
    ${!disabled &&
    !readOnly &&
    css`
      &:hover {
        color: ${theme.branding.content.primary};
        opacity: 1;
      }
    `}
  `};
`;

export const Input = styled.input<TInputProps>`
  ${mixins.position({position: 'absolute', top: 0, left: 0})}
  ${mixins.wh('100%')}
  cursor: ${({disabled}: TInputProps) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: 0;
`;

export const UploadIcon = styled(BaseUploadIcon)`
  margin-bottom: ${({theme}) => theme.spacing.s2};
`;

const getFileStyle = ({disabled, isInvalid, theme}: TTheme & TFileProps) => {
  if (disabled) {
    return css`
      background-color: ${theme.palette.grey50};
      border-color: ${theme.palette.grey50};
    `;
  }

  if (isInvalid) {
    return css`
      border-color: ${theme.palette.red300};
    `;
  }

  return css`
    border-color: ${theme.palette.grey100};
  `;
};

export const File = styled.div<TFileProps>`
  ${mixins.flexAlign('space-between', 'center')}
  border-style: solid;
  ${getFileStyle}
  ${({theme: {borderRadius, spacing, dimensions}}) => css`
    margin-top: ${spacing.s2};
    padding: ${spacing.s2} ${spacing.s4};
    border-width: ${dimensions.borderWidth}px;
    border-radius: ${borderRadius.br1};
  `}
`;

export const FileName = styled.div`
  ${mixins.truncate}
`;

export const RemoveFileButton = styled.button`
  ${mixins.pureButton}
  ${mixins.wh('24px')}
  color: inherit;

  ${({theme}) => css`
    transition: color ${theme.animation.duration}ms;

    &:hover {
      color: ${theme.branding.content.primary};
    }
  `};
`;

export const RemoveFileIcon = styled(BaseCloseIcon)`
  ${mixins.wh('100%')}
`;
